import React, {useMemo} from 'react';
import RenderPostCaption from "../ui/RenderPostCaption.tsx";
import {AssetResponseItem, GenericAsset} from "@/@types/AssetTypes.ts";
import RenderAssetsAsCollage from "../ui/RenderAssetsAsCollage.tsx";
import {extractFirstURLFromCaption} from "@/utils/func.ts";
import URLPreview from "./URLPreview.tsx";
import Avatar from "@/components/Avatar.tsx";
import DisplayRelativeTime from "@/components/DisplayRelativeTime.tsx";
import FormattedDate from "@/components/FormattedDate.tsx";

function FacebookPostPreview({
         post,
    account,
    post_at
}: {
    account?: AssetResponseItem['account']
    post_at?: string
    post: GenericAsset['post']}) {
    const url = useMemo(()=>{
        return extractFirstURLFromCaption(post.caption);
    },[post?.caption])
    return (
        <div>
            <div className={"rounded-xl overflow-hidden"}>
                {
                    account ?
                        <div className="flex gap-2 px-3 py-2">
                            <Avatar alt={account.name} src={account.picture?.url} size={48}/>
                            <div>
                                <span className={"block font-semibold"}>{account.name}</span>
                                <span className={"text-sm block opacity-50"}>Published by Timely Turtle</span>
                                <span  className={"text-sm opacity-75 font-semibold"}>
                                <RenderPostAt
                                    post_at={post_at}/>
                                </span>
                            </div>
                        </div> : null
                }
                <div className="p-3">
                    <RenderPostCaption caption={post.caption}/>
                </div>
                <RenderAssetsAsCollage assets={post.assets || []} />
                {
                    !post.assets?.length ?
                    <URLPreview display={"facebook"} url={url} /> : null
                }
            </div>
            {/*<pre className={"text-wrap"}>{JSON.stringify(post, null, 2)}</pre>*/}
        </div>
    );
}

function RenderPostAt({post_at}){
    return (
        post_at ? <span>
            <small className={"text-muted"}>
                <FormattedDate value={post_at}
                               month={"short"}
                               day={"numeric"}
                               hour={"numeric"}
                               hour12
                               minute={"numeric"}
                />
                {
                    new Date(post_at).getTime() < Date.now() ? null : <span>&nbsp;(
                        <DisplayRelativeTime time={post_at}/>)
                    </span>
                }
            </small>
        </span> : null
    )
}


export default FacebookPostPreview;
